import { createRoot } from "react-dom/client";
import { ErrorBoundary } from "react-error-boundary";
import { I18nextProvider } from "react-i18next";
import { QueryClientProvider } from "react-query";
import { ToasterContainer } from "../core/components/toaster-container/toaster-container";
import { queryClient } from "../core/lib/react-query";
import i18n from "./i18n";

// Polyfills
Array.isArray || (Array.isArray = (a) => `${a}` !== a && {}.toString.call(a) === "[object Array]");

if (!Array.from) {
  Array.from = (object) => [].slice.call(object);
}

function exists(node) {
  try {
    if (!node || (Array.isArray(Array.from(node)) && node.length <= 0)) {
      return false;
    }
    return true;
  } catch (error) {
    console.error(error);
    return false;
  }
}

function createAppWrapper(Component, props) {
  return (
    <QueryClientProvider client={queryClient}>
      <I18nextProvider i18n={i18n}>
        <ErrorBoundary
          fallback={
            <div className="m-10">
              <div className="alert alert-error shadow-lg">
                <span>{i18n.t("COMMONS.ERRORS.GENERAL_REFRESH_API_ERROR")}</span>
              </div>
            </div>
          }
        >
          <Component {...props} />
          <ToasterContainer />
        </ErrorBoundary>
      </I18nextProvider>
    </QueryClientProvider>
  );
}

function loadComponent(Component, node) {
  if (exists(node)) {
    let root = node;
    if (!Object.hasOwn(node, "_reactRootContainer")) {
      root = createRoot(node);
    }
    const app = createAppWrapper(Component);
    root.render(app);
  }
}

function loadModule(ModuleName, node, callback) {
  if (exists(node)) {
    return new ModuleName(node, callback);
  }
  return null;
}

function loadModules(ModuleName, node, callback) {
  if (exists(node) && Array.isArray(Array.from(node))) {
    return [...node].map((singleNode) => {
      return new ModuleName(singleNode, callback);
    });
  }
  return null;
}

class Loader {}

Loader.loadComponent = loadComponent;
Loader.loadModule = loadModule;
Loader.loadModules = loadModules;

export default Loader;

export { loadComponent, loadModule, loadModules };
